var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        {
          staticClass: "text-left right-inner-addon mb-4",
          attrs: { cols: "12" },
        },
        [
          _c(
            "div",
            { staticClass: "right-inner-addon" },
            [
              _c("icon", { attrs: { name: "search" } }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.search,
                    expression: "search",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control search-inactive-clients",
                attrs: {
                  id: "search-campaigns",
                  type: "search",
                  placeholder: "" + _vm.$t("campaigns.actions.searchFor"),
                  autocomplete: "off",
                },
                domProps: { value: _vm.search },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.search = $event.target.value.trim()
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "search-campaigns" } },
                [_vm._v(_vm._s(_vm.$t("campaigns.actions.searchFor")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "div",
          { staticClass: "card container-fluid" },
          [
            _c("navbar", {
              attrs: {
                "container-class": _vm.isDataEmpty ? "bb-0" : "",
                "current-tab": _vm.currentTab,
                tabs: _vm.tabs,
              },
              on: { "tab-change": _vm.handleTabChange },
            }),
            _vm._v(" "),
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "p-3" },
                  [_c("marketing-campaign-table-loader")],
                  1
                )
              : _vm.isDataEmpty
              ? _c("v-client-table", {
                  ref: "campaignsTable",
                  staticClass:
                    "marketing-campaign-table vue-custom-table no-pagination",
                  attrs: {
                    data: _vm.filteredCampaigns,
                    columns: _vm.columns,
                    options: _vm.options,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "name",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "b-row",
                            { staticClass: "align-items-center" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-md-block d-none",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid rounded-circle lg",
                                    attrs: {
                                      src: require("@Shared/assets/img/email.png"),
                                      alt: _vm.$t("global.words.profilePhoto"),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-self-center",
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "bold clickable text-primary",
                                      attrs: {
                                        to: _vm.campaignDetailsLink(row),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(row.name) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "small text-uppercase" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "campaigns.messages.lastEdited"
                                            )
                                          ) +
                                          ":\n                "
                                      ),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatTimeAgo")(
                                              row.updatedAt
                                            )
                                          ) + " "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "deliveryDateIndicator",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "p",
                            {
                              staticClass:
                                "bold small text-uppercase mb-0 regular-line-height px-md-2",
                              class:
                                row.status === "cancelled"
                                  ? "text-danger"
                                  : "text-grey",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.campaignsStatus[row.status]) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "deliveryDate",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "p",
                            {
                              staticClass:
                                "small text-uppercase text-gray mb-0 regular-line-height px-md-2",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$options.filters.formatDateHour(
                                      row.status === "cancelled"
                                        ? row.updatedAt
                                        : row.scheduledDate
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c(
                                "span",
                                { staticClass: "small d-md-block d-none" },
                                [
                                  _vm._v(
                                    "\n              (" +
                                      _vm._s(
                                        _vm.$options.filters.formatTimeAgo(
                                          row.status === "cancelled"
                                            ? row.updatedAt
                                            : row.scheduledDate
                                        )
                                      ) +
                                      ")\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "actions",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex flex-column align-items-end justify-content-end",
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-white btn-sm d-xl-inline d-none mr-3 bold px-4",
                                      attrs: {
                                        to: _vm.campaignDetailsLink(row),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "campaigns.actions.viewCampaign"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("notification-popover", {
                                    staticClass: "d-xl-inline d-none",
                                    attrs: {
                                      triggers:
                                        row.status === "sent" ? "" : "hover",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "popoverContent",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "campaigns.messages.campaignNotSent"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "popoverTarget",
                                          fn: function () {
                                            return [
                                              _c(
                                                "simple-button",
                                                {
                                                  attrs: {
                                                    "class-name": "btn-sm px-4",
                                                    disabled:
                                                      row.status !== "sent",
                                                    loading:
                                                      _vm.loadingStats ===
                                                      row.campaignId,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showCampaignResults(
                                                        row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "global.actions.viewResults"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                  _c("icon", {
                                                    attrs: {
                                                      name: "caret-down",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button-loader",
                                    {
                                      staticClass: "d-xl-none",
                                      attrs: {
                                        loading:
                                          _vm.loadingStats === row.campaignId,
                                        "show-custom-color": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-dropdown",
                                        {
                                          attrs: {
                                            variant: "transparent",
                                            "toggle-class":
                                              "text-gray position-static",
                                            "no-caret": "",
                                            right: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "button-content",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "i",
                                                      {
                                                        staticClass:
                                                          "material-icons",
                                                      },
                                                      [_vm._v("more_vert")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "b-dropdown-item",
                                            {
                                              staticClass: "text-center",
                                              on: {
                                                click: function ($event) {
                                                  _vm.goToCampaignDetails(
                                                    _vm.campaignDetailsLink(row)
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "campaigns.actions.viewCampaign"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("notification-popover", {
                                            attrs: {
                                              triggers:
                                                row.status === "sent"
                                                  ? ""
                                                  : "hover",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "popoverContent",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "campaigns.messages.campaignNotSent"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "popoverTarget",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "b-dropdown-item",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                          attrs: {
                                                            disabled:
                                                              row.status !==
                                                              "sent",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.showCampaignResults(
                                                                row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "global.actions.viewResults"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "child_row",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "marketing-campaign-stats",
                            _vm._b({}, "marketing-campaign-stats", row, false)
                          ),
                        ]
                      },
                    },
                  ]),
                })
              : _c(
                  "no-results",
                  {
                    attrs: {
                      "img-src": require("@Shared/assets/img/email.png"),
                      "img-class": "my-2",
                      "text-class": "regular text-light-gray",
                      "text-style": "",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("tables.messages.emptyCampaigns")) +
                        "\n      "
                    ),
                  ]
                ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }